import gql from "graphql-tag";

export const updateSearchableField = gql`
  mutation updateSearchableField(
    $input: UpdateSearchableFieldInput!) {
    updateSearchableField(input: $input) {
      project {
        id
        collections {
          id
          syncing
          syncedAt
          encoding
          encodedAt
          changed
          changedAt
          searchableFields {
            field
            model
          }
        }
      }
    }
  }
`;

export const updateSearchableFieldOptions = {
  name: "updateSearchableField",
};
